export default __webpack_public_path__ + "static/media/corporate-package3.2d5492f7.png";